<template>
  <div class="view-product-edit-coupom">
    <step-title title="Cupons" description="Adicione cupons de desconto." />

    <bp-table-header class="my-6" :total="pagination.count" @refresh="refresh">
      <template #buttons>
        <bp-button
          size="md"
          label="Novo cupom"
          icon="fa-regular fa-plus"
          @click="newCoupon"
        />
      </template>
    </bp-table-header>

    <div class="text-center my-9" v-if="loading">
      <b-spinner variant="primary" />
    </div>

    <bp-data-table :data="coupons" :columns="columns" v-else />

    <responsive-modal
      size="lg"
      v-model="modal"
      :title="selectedCoupon ? 'Editar cupom' : 'Novo cupom'"
    >
      <coupon-modal
        :coupon="selectedCoupon"
        @close="modal = false"
        @refresh="refresh"
      />
    </responsive-modal>
    <div
      v-if="!loading && coupons.length"
      class="d-flex justify-content-lg-end mt-5"
    >
      <bp-paginator
        v-model="currentPage"
        :pagination="pagination"
        @change-page="dispatch"
      />
    </div>
  </div>
</template>

<script>
import CouponModal from "@/components/product/coupons/CouponModal.vue";
import { formatMoney, toHumanDate } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  components: { CouponModal },
  data() {
    return {
      currentPage: 1,
      loading: false,
      selectedCoupon: null,
      modal: false
    };
  },
  computed: {
    ...mapState("product", ["coupons", "pagination", "product"]),
    ...mapState("offer", ["offers"]),
    ...mapState("plan", ["plans"]),
    isSignature() {
      return this.product?.type_product === "signature";
    },
    columns() {
      return [
        {
          name: "Nome",
          field: "code"
        },
        {
          name: "Desconto",
          field: "discount",
          transform: v => "R$" + formatMoney(v)
        },
        {
          name: "Limite de uso",
          field: "limit_max"
        },
        {
          name: this.isSignature ? "Planos" : "Ofertas",
          field: "itens",
          transform: this.getItems,
          type: "popper"
        },
        {
          name: "Data de início",
          field: "start_at",
          transform: v => toHumanDate(v)
        },
        {
          name: "Data de fim",
          field: "end_at",
          transform: v => toHumanDate(v)
        },
        {
          name: "Status",
          field: "is_enable",
          transform: this.formatStatus,
          class: this.formatStatusClass
        },
        {
          name: "",
          type: "menu",
          options: item => [
            {
              label: "Editar",
              icon: "fa-light fa-pen",
              click: item => {
                this.selectedCoupon = item;
                this.modal = true;
              }
            },
            ...(item.is_active
              ? [
                  {
                    label: "Desativar",
                    icon: "fa-light fa-power-off",
                    color: "negative",
                    dialog: {
                      text: "Deseja mesmo desativar esse cupom?",
                      variant: "negative",
                      icon: "fa fa-hexagon-exclamation",
                      secondaryAction: this.changeCouponStatus,
                      buttonText: "Cancelar",
                      secondaryButtonText: "Desativar"
                    }
                  }
                ]
              : [
                  {
                    label: "Ativar",
                    icon: "fa-light fa-check",
                    color: "positive",
                    dialog: {
                      text: "Deseja mesmo ativar esse cupom?",
                      variant: "positive",
                      icon: "fa fa-hexagon-exclamation",
                      secondaryAction: this.changeCouponStatus,
                      buttonText: "Cancelar",
                      secondaryButtonText: "Ativar"
                    }
                  }
                ])
          ]
        }
      ];
    },
    tableSizes() {
      return {
        desktop: "2.5fr 0.7fr 0.7fr 1fr 0.7fr 0.7fr 0.5fr",
        mobile: "2fr 1fr 0.5fr"
      };
    }
  },
  methods: {
    getItems(items) {
      const options = this.isSignature ? this.plans : this.offers;
      const field = this.isSignature ? "plan_id" : "offer_id";
      return items
        .map(i => options.find(opt => opt.id == i[field])?.name)
        .filter(i => !!i);
    },
    newCoupon() {
      this.selectedCoupon = null;
      this.modal = true;
    },
    refresh() {
      this.currentPage = 1;
      this.dispatch();
    },
    dispatch(offset) {
      this.loading = true;
      this.$store
        .dispatch("product/getCoupons", {
          product_id: this.$route.params.id,
          offset: offset || 0
        })
        .finally(() => (this.loading = false));
    },
    changeCouponStatus(coupon) {
      coupon.is_active = !coupon.is_active;
      this.$store
        .dispatch("product/editCoupon", coupon)
        .then(() => {
          this.$message.success(
            `Cupom ${!coupon.is_active ? "desativado" : "ativado"}.`
          );
          this.refresh();
        })
        .catch(() =>
          this.$message.error(
            `Erro ao ${!coupon.is_active ? "desativar" : "ativar"} cupom.`
          )
        );
    },
    formatStatus(status, item) {
      if (new Date(item.end_at) < new Date()) return "Expirado";
      return status ? "Ativo" : "Inativo";
    },
    formatStatusClass(status) {
      return status ? "active-badge" : "inactive-badge";
    }
  },
  mounted() {
    const action = this.isSignature ? "plan/get" : "offer/get";
    this.$store.dispatch(action, {
      product_id: this.$route.params.id,
      limit: 100
    });
    this.dispatch();
  }
};
</script>
